$('.our-brand-slider').slick({
centerMode: false,
centerPadding: '00px',
slidesToShow: 3,
arrows: false,
dots: false,
autoplay:true,
autoplaySpeed:2500,  
responsive: [
{
breakpoint: 992,
settings: {
arrows: false,
dots: false,
centerMode: false,
centerPadding: '0px',
slidesToShow: 2
}
},
{
breakpoint: 745,
settings: {
arrows: false,
dots: false,
centerMode: false,
centerPadding: '0px',
slidesToShow: 1
}
}
]
});
